<template>
  <div class="app-container" style="padding:0;">
    <list row-key="UserId" ref="list" unit="合并工单" :page="page" show-query :query-params="params" :get-data-func="api.getDocList" @reset="$refs.picker.clear()" show-checkbox
      @check-change="onCheckChange2">
      <template slot="query">
        <el-form-item el-form-item label="单据日期">
          <range-picker style="width:180px !important;" ref="picker" @change="(x) => {params.DocDateStart=x.Start;params.DocDateEnd=x.End}" />
        </el-form-item>
        <el-form-item label="存货名称">
          <el-input style="width:180px;" clearable v-model="params.ProductName" placeholder="请输入存货名称" />
        </el-form-item>
        <el-form-item label="加工阶段">
          <el-select clearable v-model="params.Stage" style="width:180px;">
            <el-option v-for="item in processList" :key="item.ItemValue" :label="item.ItemText" :value="item.ItemValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模具名称">
          <el-input style="width:180px;" clearable v-model="params.MouldName" placeholder="请输入模具名称" />
        </el-form-item>
        <el-form-item label="工单号">
          <el-input style="width:180px;" clearable v-model="params.WorkDocNo" placeholder="请输入工单号" />
        </el-form-item>
        <el-form-item label="订单号">
          <el-input style="width:180px;" clearable v-model="params.OrderNo" placeholder="请输入订单号" />
        </el-form-item>
        <el-form-item label="部门" v-if="params.ProductionType===0">
          <el-input style="width:180px;" clearable v-model="params.DpName" placeholder="请输入部门" />
        </el-form-item>
        <el-form-item label="加工商" v-if="params.ProductionType===1">
          <el-input style="width:180px;" clearable v-model="params.TradeUnitName" placeholder="请输入加工商" />
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DocDate" label="单据日期" :formatter="dateFormat" min-width="120" align="left"></el-table-column>
        <el-table-column prop="WorkDocNo" label="工单号" min-width="130" align="left"></el-table-column>
        <el-table-column prop="ProductName" label="存货名称" min-width="120" align="left"></el-table-column>
        <el-table-column prop="MouldName" label="模具名称" min-width="120" align="left"></el-table-column>
        <el-table-column prop="PropertyName" label="属性" min-width="120" align="left">
        </el-table-column>
        <el-table-column prop="ColorName" label="颜色" min-width="120" align="left">
        </el-table-column>
        <el-table-column prop="Quantity" label="数量" min-width="120" align="right">
          <template slot-scope="{ row }">
            <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Stage" label="加工阶段" min-width="120" align="left">
          <template slot-scope="{ row }">
            <span v-for="item in processList" v-if="row.Stage === item.ItemValue">{{item.ItemText}}</span>
          </template>
        </el-table-column>
        <el-table-column v-if="params.ProductionType===0" prop="DpName" label="部门" min-width="120" align="left"></el-table-column>
        <el-table-column v-if="params.ProductionType===1" prop="TradeUnitName" label="加工商" min-width="120" align="left"></el-table-column>
        <el-table-column prop="ProgrammeName" label="工艺方案" min-width="120" align="left"></el-table-column>
      </template>
    </list>
    <div style="margin-top: -30px;float: right;">
      <el-button type="primary" @click="getDetails">查询</el-button>
    </div>
    <el-table border class="table_bottom table-line tb-c-head" :data="tableData" style="margin-top: 18px;" @selection-change="onCheckChange">
      <el-table-column type="selection" align="center" fixed :width="50" />
      <el-table-column prop="WorkDocNo" label="工单号" min-width="130" align="left"></el-table-column>
      <el-table-column prop="ProductNo" label="存货编码" min-width="100" align="center"></el-table-column>
      <el-table-column prop="ProductName" label="存货名称" min-width="100" align="center"></el-table-column>
      <el-table-column prop="PropertyName" label="属性" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.PropertyName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="ColorName" label="颜色" min-width="100" align="center">
        <template slot-scope="{ row }">
          <span>{{row.ColorName}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Quantity" label="数量" min-width="100" align="center"></el-table-column>
    </el-table>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import moment from "moment"

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  props: {
    tempParams: {
      typeof: Object,
      default: () => { },
    },
    type: {
      type: Boolean,
      default: true,
    },
    docType: {
      type: Number,
      default: 1
    },
    tableType: {
      type: Number,
      default: 0,
    },
    DictionaryId: {
      type: Number,
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    processList: {
      type: Array,
      default: () => [],
    }
  },
  watch: {
    tempParams(val) {
      this.params.status = val.status
      this.params.ProductionType = val.ProductionType
      this.params.Stage = val.Stage
      this.params.OrderType = val.OrderType ?? 0
    },
  },
  data() {
    return {
      params: {
        DocDateStart: "",
        DocDateEnd: "",
        ProductName: "",
        Stage: "",
        MouldName: "",
        WorkDocNo: "",
        OrderNo: "",
      },
      data: {},
      commonApi: require("@/api/common/common").default,
      api: require('@/api/production/workDoc').default,
      //加工类型
      machiningStageApi: require("@/api/ba/machiningStage").default,
      ProductionPhaseOptions: [
        // { ItemText: '注塑', ItemValue: 0 },
        // { ItemText: '特殊工艺', ItemValue: 1 },
        // { ItemText: '配件', ItemValue: 2 },
        // { ItemText: '装配', ItemValue: 3 },
        // { ItemText: '组合', ItemValue: 4 },
      ],
      selectList: [],
      arr: [],
      routesName: '',
      list: [],
      subList: [],
      tableData: [],
      extraList: [],
      TradeUnitId: null,
    };
  },
  created() {
    this.getParams()
  },
  mounted() {
    this.getData();
  },
  methods: {
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined || date == '') {
        return ''
      }
      return moment(date).format("YYYY-MM-DD")
    },
    getParams() {
      // console.log('this.tempParams', this.tempParams)
      this.params.status = this.tempParams.status
      this.params.ProductionType = this.tempParams.ProductionType
      this.params.OrderType = this.tempParams.OrderType

      if (this.tableType === 1) {
        this.params.Stage = this.tempParams.Stage
      }
      // this.machiningStageApi.list({ Status: 1,Universal:true }).then((res) => {
      //   res.Data.forEach((item) => {
      //     this.ProductionPhaseOptions.push({ItemText: item.Name,ItemValue: item.MachiningStageId});
      //   })
      // });
      
      // if(this.DictionaryId>0){
      //   this.params.ProcessStage=this.DictionaryId
      // }
    },
    del() { },
    checkChange(list) {
      this.list = list;
    },
    clear() {
      this.list = [];
      this.subList = [];
    },
    onCheckChange(list) {
      this.subList = list;
    },
    onCheckChange2(data) {
      this.selectList = data;
    },
    getDetails() {
      console.log("getDetails", JSON.parse(JSON.stringify(this.selectList)));
      var ids = this.selectList.map(x => x.WorkDocId);
      this.api.infoList({ ids }).then(res => {
        this.extraList = []
        if (res.Code === 0) {
          // this.TradeUnitId = res.Data.ProductionDpId ?? null;
          this.tableData = [];
          res.Data.forEach(x => {
            x.ProductModels.forEach(item => {
              item.WorkShopId = x.DpId
              item.WorkShopName = x.DpName
              item.ProductionType = x.WorkDocType
              item.UnitId = item.Unit;
              if (this.docType === 1) {
                item.Quantity = item.Quantity - (item.StInDocOccupyQuantity ?? 0);
              } else {
                item.Quantity = item.Quantity - (item.StDirectInDocOccupyQuantity ?? 0);
              }
              this.tableData.push(item);
            })
          })
          console.log("this.tableData", this.tableData);
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    onClear() {
      this.selectList = [];
      this.tableData = [];
    }
  },
};
</script>
